// extracted by mini-css-extract-plugin
export default {"iris":"#5252cc","flame":"#de5d1d","seaGreen":"#1fbfbd","navy":"#444e86","yellow":"#f3c771","blue":"#49bcf5","black":"#000","gray":"#e0e0e0"};